import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { SectionHeading, EmptySection, Field, StatusBadge, BoolBadge, formatTimestamp } from './shared';

interface Props {
  data: any[];
}

export default function PermitsSection({ data }: Props) {
  return (
    <section>
      <SectionHeading id="section-permits" title="Permits to Work" count={data.length} />
      {data.length === 0 ? (
        <EmptySection name="permits" />
      ) : (
        <div className="mt-2 space-y-3">
          {data.map((row: any) => (
            <Card key={row.id}>
              <CardContent className="pt-4">
                <div className="mb-2 flex items-center gap-2">
                  <Badge variant="outline">
                    {(row.permit_type ?? '').replace(/_/g, ' ')}
                  </Badge>
                  <StatusBadge status={row.status} />
                  <span className="text-sm font-medium">{row.permit_number}</span>
                </div>
                <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
                  <Field label="Issued By" value={row.issued_by} />
                  <Field label="Issued At" value={formatTimestamp(row.issued_at)} />
                  <Field label="Expires At" value={formatTimestamp(row.expires_at)} />
                  <Field label="Work Location" value={row.work_location} />
                  <Field label="Verified" value={<BoolBadge value={row.is_verified} />} />
                  <Field label="Verified By" value={row.verified_by} />
                  <Field label="Verified At" value={formatTimestamp(row.verified_at)} />
                  <Field label="Activity" value={row.activity_description} />
                  {row.comments && (
                    <div className="col-span-full">
                      <Field label="Comments" value={row.comments} />
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </section>
  );
}
